import {PVAFormData} from "@commons/mapping/PVAFormData";
import {ModalPanel} from "@components/Modal2023";
import PVAFilter from "../../../PVA/PVAFilter";
import React, {useCallback, useEffect, useState} from "react";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {UseFormReturn} from "react-hook-form/dist/types";
import {useGetFilterQuery, useUpdateFilterMutation} from "@commons/features/PVA/RML/PVAFilter.api";
import {MutationError} from "../../../../core/editor";
import {toastAsError} from "@utilities/toastAsError";
import {PaginationReturnType} from "@components/dataTable/usePagination";

interface ModalPVAFilterParams {
    azienda: AziendaRecord,
    hookPvaFilter: UseFormReturn<PVAFormData, PVAFormData>,
    filterOpen: boolean,
    setFilterOpen: React.Dispatch<React.SetStateAction<boolean>>,
    pagination?: PaginationReturnType<PVAFormData>,
}

export const ModalPVAFilter: React.FC<ModalPVAFilterParams> = ({azienda, hookPvaFilter, filterOpen, setFilterOpen, pagination}) => {
    const reset = hookPvaFilter.reset;
    // Gestione filtro PVA
    // Query per ripristinare l'ultimo filtro utilizzato (relativo alla sessione corrente)
    const {data: lastPvaFilter, isLoading: isLoadingLastPvaFilter} = useGetFilterQuery({idAziendaMaster: azienda?.idAziendaMaster}, {skip: !azienda});
    const [updatePvaFilter, updatePvaFilterResult] = useUpdateFilterMutation(); // Mutation per update del filtro

    // Logica inizializzazione iniziale sia del form sia del effettivo filtro!
    const [firstTime, setFirstTime] = useState<boolean>(true);
    useEffect(() => {
        if (lastPvaFilter && firstTime) {
            setFirstTime(false);
            const filter = PVAFormData.factory(lastPvaFilter);
            reset(filter); // Imposto ultimo filtro della sessione
            if (pagination && pagination.setSearch)
                pagination.setSearch(filter);
        }
    }, [firstTime, pagination, reset, lastPvaFilter]);

    const updSession = useCallback((pvaFormdata: PVAFormData) => {
        updatePvaFilter({...pvaFormdata, idAziendaMaster: azienda.idAziendaMaster})
            .unwrap()
            .then((data) => {
                //toast('Filtro aggiornato!', {type: 'success'})
                reset(pvaFormdata); // Consolido form con nuovi valori! (reset isDirty!!!)
                setFilterOpen(false); // Chiudo accordion filtro PVA
                if (pagination && pagination.setSearch)
                    pagination.setSearch(pvaFormdata);
            })
            .catch((error: MutationError) => {
                // @ts-ignore
                const message = error.data.message;
                toastAsError(message);
            })
    }, [pagination, setFilterOpen, updatePvaFilter, azienda, reset]);

    const handleReset = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        updSession(PVAFormData.factory());
    }

    const handleApply = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        hookPvaFilter.handleSubmit((pvaFormdata) => {
            updSession(pvaFormdata);
        })();
    };

    return <ModalPanel
        isOpen={filterOpen}
        handleDismiss={() => {
            setFilterOpen(false);
        }}
        bgColor="bg-gray-50"
        margin="mx-12"
    >
        <div className="mt-2 rounded-md bg-white shadow">
            <PVAFilter idAzienda={azienda?.idAziendaCDIC}
                       open={true}
                       setOpen={setFilterOpen}
                       useFormReturn={hookPvaFilter}
            ></PVAFilter>

            <div className="mr-8 pb-4 flex flex-row justify-end">
                <button type="button"
                        className="mr-2 inline-flex justify-center p-1.5 sm:p-2 md:py-2 md:px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600
                                                                    max-lg:mb-1
                                                                    hover:bg-blue-700
                                                                    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
                                                                    disabled:opacity-50"
                        onClick={handleReset}>
                    Reset filtro
                </button>

                <button onClick={handleApply}
                        className="btnPrimary"
                        disabled={false}>
                    Applica selezione
                </button>
            </div>
        </div>
    </ModalPanel>
}
export default ModalPVAFilter;